// Dependencies
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'

// Pages
import Home from './pages/Home'
import Chat from './pages/Chat'
import About from './pages/About'
import Resources from './pages/Resources'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import Register from "./pages/Register"
// import ChatPage from './pages/NewChat'

// Styling
import './App.css';



// Initialize Lenis (Smooth Scrolling) only for desktops
// const screenWidth = window.innerWidth;

// if (screenWidth >= 1200) {
//   const lenis = new Lenis({
//     autoRaf: true,
//   });

//   // Exclude #chat-logs from Lenis scrolling
//   lenis.on('scroll', ({ target }) => {
//     const chatLogs = document.getElementById('chat-logs');
//     if (chatLogs && chatLogs.contains(target)) {
//       return; // Let native scrolling handle #chat-logs
//     }
//   });

//   // Start Lenis animation loop
//   function raf(time) {
//     lenis.raf(time);
//     requestAnimationFrame(raf);
//   }
//   requestAnimationFrame(raf);
// }


function App() {
  return (
    <div className="App">
      <BrowserRouter>
      {/* <ScrollToHash /> */}
        <Routes>
          <Route index element = {<Home/>}/>
          <Route path = "/" element = {<Home/>}/>
          <Route path = "/chat" element = {<Chat/>}/>
          {/* <Route path = "/chat-new" element = {<ChatPage/>}/> */}
          <Route path = "/resources" element = {<Resources/>}/>
          <Route path = "/about" element = {<About/>}/>
          <Route path = "/register" element = {<Register/>}/>
          <Route path = "/privacy-policy" element = {<PrivacyPolicy/>}/>
          <Route path = "/terms-of-service" element = {<TermsOfService/>}/>
          <Route path = "*" element = {<Home/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
